import * as React from 'react';

import {Project} from "../../../../domain/model/project";
import {Entry} from "../../../../domain/model/entry";
import {Contract} from "../../../../domain/model/contract";
import {Customer} from "../../../../domain/model/customer";

import Progress from "../../../common/organism/progress";
import ClientEntriesMain from "./client_entries_main";

import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import {TBreadcrumbItem} from "../../../type/common";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";

interface IProps {
    isInit: boolean;
    isLoading: boolean;
    project: Project | null;
    entries: Entry[];
    customers: Customer[];
    contracts: Contract[];
}

const ClientEntriesComponent: React.FC<IProps> = (props) => {

    const {isInit, isLoading, project, entries, customers, contracts,
    } = props;

    // 初期化
    if (isInit) { return <Progress canAnimation={false}/>}

    const projectName = project ? project.name : "";

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientProjects,
        {text: `[エントリー一覧]${projectName}`}
    ]

    return (
        <React.Fragment>

            {isLoading && <Progress canAnimation={false}/>}

            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />
                <ClientEntriesMain
                    project={project}
                    entries={entries}
                    customers={customers}
                    contracts={contracts}
                />
            </PageWrapper>
        </React.Fragment>
    )

};

export default ClientEntriesComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/entries/client_entries.tsx